import React, { ReactNode } from 'react';
import cx from 'classnames';

interface TableDataStatusProps {
    addClasses?: string;
    data: ReactNode;
    draft: boolean;
}

/**
 * A simple wrapper for some table data which uses gray font and italicized text to indicate when
 * the data is in a draft state.
 */
export const TableDataStatus = ({
    addClasses,
    data,
    draft,
}: TableDataStatusProps): JSX.Element => (
    <div
        className={cx(
            'flex items-center',
            {
                'text-tertiary-400 italic': draft,
            },
            addClasses,
        )}
    >
        {data}
    </div>
);
